import type { SecuritySettingsFeatureConfig } from '../type';

export const securitySettingsConfig: Partial<SecuritySettingsFeatureConfig> = {
    externalClientId: 'ssp',
    externalTargets: ['alias', 'secret'],
};
